/** This file is auto generated by convertSvgToJsx.ts */

import icon from './dnb/digipost_medium'
export default icon
